<header class="dialog__header">
  <h2 class="dialog__title">Invited Users</h2>
</header>
<mat-dialog-content>
  <ul class="invited-users-dialog__users">
    @for (user of invitedUsers; track user.uuid) {
      <li class="invited-users-dialog__user">
        <div>
          <b>{{ user.userModel.name }}</b> is invited as <b>{{ user.invitationType }}</b>
        </div>
        @if (canRemove) {
          <button
            class="invited-users-dialog__remove"
            procure-button
            (click)="removeUser(user)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </li>
    }
  </ul>
</mat-dialog-content>
<footer class="dialog__footer">
  <button
    id="share-dialog-send"
    type="button"
    procure-button
    color="primary"
    (click)="onClose()"
  >
    Close
  </button>
</footer>
